import { FlexBox } from '@dixa/lib-shared-habla';
import type { ConversationWrapupMessageEvent } from 'lib-shared-types-api';
import { ComponentProps } from 'react';

import { HTMLShadowDomRenderer } from 'components/HTMLShadowDomRenderer';
import { ConversationEventGroupConfigBase } from 'components/conversation/conversationEventGroups/conversationEventGroups.types';

import { ConversationTextualMessage } from '../../textualMessage/conversationTextualMessage';
import { ConversationTextualMessagePropBase } from '../../textualMessage/conversationTextualMessage.types';

/** Represents the conversation email event group configuration. */
export type ConversationInternalNoteEventGroupConfig =
  ConversationEventGroupConfigBase<
    'group:conversation:wrapup_message',
    Pick<ConversationInternalNoteEventGroupProps, 'hideGutterActions'>
  >;

type ConversationInternalNoteEventGroupProps =
  ConversationTextualMessagePropBase<
    ConversationWrapupMessageEvent,
    Pick<
      ComponentProps<typeof ConversationTextualMessage.Events>,
      'hideAttachments'
    >
  >;

/**
 * Represents the component for displaying a conversation internal note event
 * group.
 */
export const ConversationInternalNoteEventGroup = ({
  author,
  className,
  events,
  hideGutterActions,
}: ConversationInternalNoteEventGroupProps): JSX.Element => {
  const timestamp = events[events.length - 1].created_at;

  return (
    <ConversationTextualMessage
      className={className}
      author={author}
      timestamp={timestamp}
      hideGutterActions={hideGutterActions}
      variant="internalNote"
    >
      <FlexBox
        flexDirection="column"
        gap="200"
        style={{ wordBreak: 'break-word' }}
      >
        {events.map((event) => (
          <FlexBox key={event.id} flexDirection="column" gap="100">
            <HTMLShadowDomRenderer html={event.message} />
          </FlexBox>
        ))}
      </FlexBox>
    </ConversationTextualMessage>
  );
};
